import { defineMessages } from 'react-intl';

export const uomUpsellEmptyStateMessages = defineMessages({
  bannerTitle: {
    id: 'Ua/1Ys',
    defaultMessage: 'Units of measure is not included in your current subscription plan',
    description: 'Upsell banner title for UoM plan gating',
  },
  bannerSubtitle: {
    id: 'CKHtAP',
    defaultMessage: 'This feature is exclusive to higher-tier plans—upgrade now to access it and more.',
    description: 'Upsell banner subtitle for UoM plan gating',
  },
  upgradeButton: {
    id: 'D5ym6N',
    defaultMessage: 'Upgrade',
    description: 'Button text for upgrading subscription plan',
  },
  sampleConversionLine1: {
    id: 'Rk2Vtu',
    defaultMessage: '1 Pack = 10 x Each',
    description: 'Sample conversion summary line 1 in UoM upsell preview',
  },
  sampleConversionLine2: {
    id: '9k3kbD',
    defaultMessage: '1 Case = 5 x Pack = 50 x Each',
    description: 'Sample conversion summary line 2 in UoM upsell preview',
  },
  sampleConversionLine3: {
    id: '+gFw4e',
    defaultMessage: '1 Pallet = 10 x Case = 50 x Pack = 500 x Each',
    description: 'Sample conversion summary line 3 in UoM upsell preview',
  },
});
